var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgButtonFolder = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M2.667 9.17v2.876c0 .158.15.288.333.288h10c.184 0 .334-.13.334-.288V6.319c0-.16-.15-.288-.334-.288H8c-.2 0-.39-.09-.516-.245L5.751 3.667H3c-.185 0-.334.129-.334.287V9.17zM13 13.667H3c-.918 0-1.667-.727-1.667-1.621V3.954c0-.894.749-1.62 1.667-1.62h3.067c.2 0 .39.089.516.244l1.733 2.12H13c.919 0 1.667.726 1.667 1.62v5.728c0 .894-.748 1.621-1.667 1.621z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgButtonFolder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/button_folder.0f4ab045.svg";
export { ForwardRef as ReactComponent };